// src/utils/commonIssues.js
export const COMMON_ISSUES = {
    'syntax': {
      patterns: ['SyntaxError', 'unexpected token', 'missing', 'expected', 'Unexpected identifier'],
      guidance: 'シンタックスエラーは構文の誤りです。コードの書き方に何か間違いがあります。',
      tips: [
        '括弧やブラケットが正しく閉じられているか確認',
        'セミコロンの抜けがないか（省略可能ですが、明示的につけるのが良い習慣です）',
        'キーワードのスペルミス（例：functon → function）がないか',
        '文字列の引用符が正しく閉じられているか',
        'コンマの位置が正しいか（オブジェクトや配列で特に注意）'
      ]
    },
    'scope': {
      patterns: ['ReferenceError', 'is not defined', 'undefined', 'not declared'],
      guidance: '変数が見つかりません。変数の宣言と使用範囲（スコープ）を確認しましょう。',
      tips: [
        '変数を使う前に宣言されているか（let, const, var）',
        'スコープ（使用可能範囲）内で使っているか',
        '変数名のスペルミスがないか',
        'グローバル変数とローカル変数の違いを理解しているか',
        'ブロックスコープ（{}内）での変数の可視性を確認'
      ]
    },
    'type': {
      patterns: ['TypeError', 'is not a function', 'cannot read property', 'of undefined', 'of null'],
      guidance: 'データ型が期待と異なります。変数の型や値を確認しましょう。',
      tips: [
        '関数として呼び出しているものが本当に関数か',
        'オブジェクトのプロパティが存在するか',
        'nullやundefinedに対して操作していないか',
        '配列のメソッドを配列以外のものに対して使っていないか',
        '文字列のメソッドを数値に対して使っていないか'
      ]
    },
    'range': {
      patterns: ['RangeError', 'Maximum call stack', 'Invalid array length'],
      guidance: '値の範囲や実行回数に問題があります。',
      tips: [
        '無限ループになっていないか',
        '再帰関数に終了条件があるか',
        '配列の長さが適切か',
        'スタックオーバーフローを起こしていないか'
      ]
    },
    'assignment': {
      patterns: ['Invalid left-hand side', 'Assignment to constant'],
      guidance: '代入操作に問題があります。',
      tips: [
        'constで宣言した変数を再代入していないか',
        '比較演算子（==）と代入演算子（=）を間違えていないか',
        '読み取り専用のプロパティに代入していないか'
      ]
    },
    'promise': {
      patterns: ['UnhandledPromiseRejection', 'Promise rejection', 'async function'],
      guidance: '非同期処理（Promise）に関するエラーです。',
      tips: [
        'async/awaitを使う際にtry/catchブロックを使用しているか',
        'Promiseのエラーハンドリング（.catch）を忘れていないか',
        'awaitキーワードはasync関数内でのみ使用可能',
        '非同期処理の順序を理解しているか'
      ]
    },
    'module': {
      patterns: ['import', 'export', 'Cannot use import', 'require is not defined'],
      guidance: 'モジュールのインポート/エクスポートに関するエラーです。',
      tips: [
        'importされているモジュールが存在するか',
        'exportされている名前が正しいか',
        'importとrequireを混在させていないか',
        'モジュールのパスが正しいか'
      ]
    }
  };